import React from "react";


const ProgressBar = ({ current, total, completed }) => (
  <div className="relative">
    <div className="w-full bg-gray-200 rounded-full h-3">
      <div
        className="bg-gradient-to-r from-blue-500 to-blue-600 h-3 rounded-full transition-all duration-500"
        style={{ width: `${(current / total) * 100}%` }}
      ></div>
    </div>
    <div className="flex justify-between mt-2 text-xs text-gray-500">
      <span>{completed} completed</span>
      <span>{total - current} remaining</span>
    </div>
  </div>
);

export default ProgressBar;